 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { renderCheckBox, renderTextField, renderTimePicker, renderTextArea } from '../../../../components/reduxFields';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';
import { getMasterData} from '../../../scheduling/components/SessionNotes_SOAR/actions/soapActions';


import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      timeDifference: 0.0,
      master_data: props.master_data,
      targetCaseManager: '',
      medicaidId: '',     
      leadAnalystMedicaidId: '',     
      behaviorTechnicianMedicaidId: '',  
    };
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentWillMount() {
    this.props.getMasterData();
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        let medicaidIds = [];
        let leadAnalystMedicaidIds = [];
        let behaviorTechnicianMedicaidIds = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
          medicaidIds.push(staff.medicaidId);
          leadAnalystMedicaidIds.push(staff.leadAnalystMedicaidId);
          behaviorTechnicianMedicaidIds.push(staff.behaviorTechnicianMedicaidId);
        });
        let renderingProviderNames = [];
        appointmentData.appointmentRenderingProviders.forEach((staff) => {
          renderingProviderNames.push(staff.renderingProviderName);
        });
        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          renderingProviderName: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
          timeDifference: appointmentData.timeDifference,        
          targetCaseManager: appointmentData.targetCaseManager,             
          medicaidId: medicaidIds && medicaidIds ? medicaidIds.join(',') : '',
          leadAnalystMedicaidId : leadAnalystMedicaidIds && leadAnalystMedicaidIds ? leadAnalystMedicaidIds.join(',') : '',
          behaviorTechnicianMedicaidId : behaviorTechnicianMedicaidIds && behaviorTechnicianMedicaidIds ? behaviorTechnicianMedicaidIds.join(',') : '', 
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                Name: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
                //Name: signObj.renderingProviderName ? signObj.renderingProviderName : this.state.renderingProviderName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          RenderingProviderSign: renderingProviderSignObj,
        });
      }
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,     
      });
    }
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Session Duration (In Mins):</b> <span>{this.state.timeDifference}</span>
                      </p>
                      <p>
                        <b>Targeted Case Manager:</b> <span>{this.state.targetCaseManager}</span>
                      </p>
                      <p>
                        <b>Medicaid ID:</b> <span>{this.state.medicaidId}</span>
                      </p>
                      <p>
                        <b>Lead Analyst Medicaid ID:</b> <span>{this.state.leadAnalystMedicaidId}</span>
                      </p>
                      <p>
                        <b>Behavior Technician Medicaid ID:</b> <span>{this.state.behaviorTechnicianMedicaidId}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
                {/* <div className='col-sm-6'>
                  <Field
                    name="TargetCaseManager"
                    type="text"
                    fullWidth={true}
                    label="Target Case Manager"                  
                    disabled={true}
                    component={renderTextField}                   
                  />   
                </div>  */}
              </div>
              

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>RBT Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className={'col-sm-12'} >
                  <Field
                    name="TargetBehaviorsForReduction"
                    type="text"
                    fullWidth={true}
                    label="Target Behaviors For Reduction"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>                
                <div className={'col-sm-12'} >
                  <Field
                    name="TargetBehaviorsForIncrease"
                    type="text"
                    fullWidth={true}
                    label="Replacement Skills for Increase"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                  
                  />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin require">
                    <h6><b>Behavior Analysis Service Delivery: </b>Under direct observation/training of BCBA, Registered Behavior Technician provided training to client, direct care supports and/or family, regarding implementation of all components of the BSP to include replacement skill procedures, decel procedures, antecedent/environmental manipulations, and data collection/documentation, through a combination of role-play, modeling, feedback and coaching in the home, community, and school settings.</h6>
                  </div>   
                  <div className="panel_title no_margin require mb-20">
                    <h6><b>See data sheets for specific programs implemented and data collected.</b></h6>
                  </div>                  
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-12 require">
                  <span>***Equipment utilized </span>
                  <Field
                    autoFocus={true}
                    name="NoEquipmentUtilized"
                    type="text"
                    maxLength="100"                    
                    label="Equipment Utilized"
                    component={renderTextField}
                    disabled={true}
                    />
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-12 require">
                  <span>***Supplies utilized: </span>
                  <Field
                    autoFocus={true}
                    name="SuppliesUtilized"
                    type="text"
                    maxLength="100"                    
                    label="Supplies Utilized"
                    component={renderTextField} 
                    disabled={true}
                    />
                    <span> reinforcers (edibles, potables, tangibles)</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Training Addressed During Session</h5><span style={{ color: 'red'}}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Consistency"
                    label="Consistency - Caregiver/s"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ChoiceMaking"
                    label="Choices/Choice Making"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InterventionPlan"
                    label="Intervention Plan"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AutonomyInformation"
                    label="Autonomy Information"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="JunkBehavior"
                    label="Junk Behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CommunityIntegration"
                    label="Affiliation/Community Integration"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcement"
                    label="Reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Confidentiality"
                    label="Confidentiality"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FunctionalCommunication"
                    label="Functional Communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FreeFromAbuseAndNeglect"
                    label="Free from Abuse And Neglect"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SettingExpectations"
                    label="Setting Expectations w/ Client/Caregiver"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ConsumerPreferences"
                    label="Consumer Preferences/Dislikes"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RoleModeling"
                    label="Role Modeling - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SafeAndSafeGuards"
                    label="Safe And Safeguards"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Monitoring"
                    label="Monitoring/Feedback - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IndividualRights"
                    label="Individual Rights And Fair Treatment"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis/Data Entry"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HealthAndWellness"
                    label="Health And Wellness"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Feedback"
                    label="Feedback - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ReviewClientChoice"
                    label="Review Clients Choice of Time, Date, and Place for Services Rendered"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservationalAssessment"
                    label="Observational Assessment - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Relaxation"
                    label="Relaxation/Calming Skills - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTrainingAddressed"
                    label="Other: ABC Data Collection"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTrainingAddressed &&
                  (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTrainingAddressedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className={'col-sm-12'} >
                  <Field
                    name="BehaviorIncidents"
                    type="text"
                    fullWidth={true}
                    label="Behavior Incidents: Description of behaviors targeted for decrease/replacement skills utilized/interventions utilized:"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="SkillAcquisition"
                    type="text"
                    fullWidth={true}
                    label="Skill Acquisition"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="Communication"
                    type="text"
                    fullWidth={true}
                    label="Communication"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="Adaptive"
                    type="text"
                    fullWidth={true}
                    label="Adaptive"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                {/* <div className={'col-sm-12'} >
                  <Field
                    name="BehaviorReplacementSkills"
                    type="text"
                    fullWidth={true}
                    label="Behavior Replacement Skills"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div> */}
                <div className={'col-sm-12'} >
                  <Field
                    name="ChoicesOffered"
                    type="text"
                    fullWidth={true}
                    label="Choices Offered: Choices offered during session to client e.g. reinforcers, location of therapy, activities used for programming etc.: "
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="CaregiverInvolvement"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Involvement: Narrative of caregiver participation and feedback given to caregiver:"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>

                <div className={'col-sm-12'} >
                  <Field
                    name="CaregiverHomework"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Homework"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="FollowUpCaregiverHomework"
                    type="text"
                    fullWidth={true}
                    label="Follow Up Caregiver Homework"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="ChangesToClientStatus"
                    type="text"
                    fullWidth={true}
                    label="Changes to client status: List any changes to client's mental, physical or medical status. Include changes with medication, living status, etc. "
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
              </div>
            
             
              
              

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {this.state.RenderingProviderSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageClient">
                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                                <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                    }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
    if (state.patient.singleEncounter.sessionNotes_RBT_TFABA) {
       
        
      initialData['TargetBehaviorsForReduction'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.targetBehaviorsForReduction;      
      initialData['TargetBehaviorsForIncrease'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.targetBehaviorsForIncrease;
      initialData['NoEquipmentUtilized'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.noEquipmentUtilized;
      initialData['SuppliesUtilized'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.suppliesUtilized;
      initialData['BehaviorIncidents'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.behaviorIncidents;
      initialData['SkillAcquisition'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.skillAcquisition;
      initialData['Communication'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.communication;
      initialData['Adaptive'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.adaptive;
      //initialData['BehaviorReplacementSkills'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.behaviorReplacementSkills;
      initialData['ChoicesOffered'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.choicesOffered;
      initialData['CaregiverInvolvement'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.caregiverInvolvement;
      initialData['CaregiverHomework'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.caregiverHomework;
      initialData['FollowUpCaregiverHomework'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.followUpCaregiverHomework;
      initialData['ChangesToClientStatus'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.changesToClientStatus;
      //initialData['TargetCaseManager'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.targetCaseManager;

        // TrainingAddressed       

        initialData['Consistency'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].consistency;
        initialData['ChoiceMaking'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].choiceMaking;
        initialData['InterventionPlan'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].interventionPlan;
        initialData['AutonomyInformation'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].autonomyInformation;
        initialData['JunkBehavior'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].junkBehavior;
        initialData['CommunityIntegration'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].communityIntegration;
        initialData['Reinforcement'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].reinforcement;
        initialData['Confidentiality'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].confidentiality;
        initialData['FunctionalCommunication'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].functionalCommunication;
        initialData['FreeFromAbuseAndNeglect'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].freeFromAbuseAndNeglect;
        initialData['SettingExpectations'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].settingExpectations;
        initialData['ConsumerPreferences'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].consumerPreferences;
        initialData['RoleModeling'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].roleModeling;
        initialData['SafeAndSafeGuards'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].safeAndSafeGuards;
        initialData['Monitoring'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].monitoring;
        initialData['IndividualRights'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].individualRights;
        initialData['TaskAnalysis'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].taskAnalysis;
        initialData['HealthAndWellness'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].healthAndWellness;
        initialData['Feedback'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].feedback;
        initialData['ReviewClientChoice'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].reviewClientChoice;
        initialData['ObservationalAssessment'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].observationalAssessment;
        initialData['Relaxation'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].relaxation;
        initialData['OtherTrainingAddressed'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].otherTrainingAddressed;
        initialData['OtherTrainingAddressedNotes'] = state.patient.singleEncounter.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].otherTrainingAddressedNotes;
     
    }
    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  return {
    selectorOtherTrainingAddressed: selector(state, 'OtherTrainingAddressed'),
    
    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,
    master_data: state.soap.master_data,
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounters, getMasterData })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/SessionNotes_Encounter_RBT_TFABA.js